// extracted by mini-css-extract-plugin
export default {"button":"DeletionInput_button__uquYt"};